/* eslint-disable */ 
import React from 'react'; 
import BoardList from '../modules/BoardList';

export default function SupportList(prop) {
    return ( 
        <BoardList lang={prop.lang} type={prop.type} />
    ); 
}; 